import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-add-customer',
  templateUrl: './add-customer.component.html',
  styleUrls: ['./add-customer.component.css']
})
export class AddCustomerComponent implements OnInit {

  @Input() previewLogo: File;
  @Input() subcustomer: boolean;

  @Output() addCustomer = new EventEmitter<Object>();
  @Output() addLogo = new EventEmitter();
  @Output() addFile = new EventEmitter<object>();

  @ViewChild('dialogAddCustomer') public dialogAddCustomer: TemplateRef<any>;
  private modalAddCustomer: NgbModalRef;
  currentUser;

  constructor(
    private modalService: NgbModal,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.authService.LoggedinUser
    .subscribe(
      user => {
        this.currentUser = user;
      }
    );
  }

  open(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.modalAddCustomer = this.modalService.open(this.dialogAddCustomer)
      this.modalAddCustomer.result.then(resolve, resolve)
    })
  }

  async close(): Promise<void> {
    this.modalAddCustomer.close()
  }

  logoFile = null;
 // previewLogo = null;
  chooseLogo() {
    this.addLogo.emit()
  }

  getFile(event) {
    this.addFile.emit(event)
  }

  sendCustomer(customerForm) {
    console.log(customerForm.form.value)
    this.addCustomer.emit(customerForm);
  }

}
